var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{class:{ 'info__title': _vm.title }},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_c('td',{class:{ 'info__title': _vm.title }},[_vm._v("\n    "+_vm._s(_vm.value)),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }